document.addEventListener('DOMContentLoaded', () => {
    const showChildMenuFooter = document.querySelectorAll('.js-footer-show-children')

    if(showChildMenuFooter) {
        showChildMenuFooter.forEach((key, val) => {
            key.addEventListener('click', toggleChildrenMenuFooter)
        });
    }

    function toggleChildrenMenuFooter() {
        this.classList.toggle("active")
        document.body.addEventListener('click', ({target}) => {
            if (!target.closest('.js-footer-show-children')) {
                this.classList.remove('active');
                return;
            }
        })
    }
});
